import React, {useEffect, useState} from 'react';
import { useLocation, Link } from "react-router-dom";
import { useHistory } from 'react-router';
import Header_admin from '../../../Layout/Header_admin';
import Footer_admin from '../../../Layout/Footer_admin';
import Sidebar_admin from '../../../Layout/Sidebar_admin';

import { edit_type_price } from '../../../Context/actions';
import LoadingBar from 'react-top-loading-bar';


function Edit_type_price() {
    const location = useLocation()
    const params = new URLSearchParams(location.search)

    const [typePriceEdit, setTypePriceEdit] = useState([]);

    const [namaTypePrice, setNamaTypePrice] = useState();
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0)

    const history = useHistory();

    useEffect(() => {
        setProgress(progress + 40)
        const fetchData = async () => {
            
          const res = await fetch(
            'https://athaexpress.net/backend/ongkir/api/editTypePrice/'+params.get("id"),
          );
          const json = await res.json();
          setProgress(100)
          setTypePriceEdit(json.data);
          
        };
        fetchData();
    },[]);

    const handleonSubmit = async e => {
    e.preventDefault();
        setLoading(true)
        setProgress(progress + 40)
        //console.log(login(username,password));
        const promise_login = Promise.resolve(edit_type_price(params.get("id"),namaTypePrice));

        promise_login.then((value) => {
            if(value.hasil == '1'){
                setLoading(false)
                setProgress(100)
                alert(value.message);
                history.push('/type_price');
                window.location.reload(true);
            }else if(value.hasil == '2'){
                setLoading(false)
                setProgress(100)
                alert(value.message);
                history.push('/type_price');
                window.location.reload(true);
            }
        });
    }

    

  return (
 
        <div>
            <LoadingBar
              color='#f11946'
              progress={progress}
              onLoaderFinished={() => setProgress(0)}
            /> 
            <Header_admin></Header_admin>
            <main id="main" class="main">

              <div class="pagetitle">
                <h1>Edit Type Price</h1>
                <nav>
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                    <li class="breadcrumb-item"><Link to="/type_price">Type Price</Link></li>
                    <li class="breadcrumb-item active">Edit Type Price</li>
                  </ol>
                </nav>
              </div>

              <section class="section">
                <div class="row">
                  <div class="col-lg-12">

                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title">Edit Type Price</h5>
                            <form onSubmit={handleonSubmit}>
                            {typePriceEdit.map(item => (
                            <div class="row mb-3">
                                <label for="inputText" class="col-sm-2 col-form-label">Nama Negara</label>
                                <div class="col-sm-10">
                                <input type="text" class="form-control" name="namaCountry" id="namaCountry" defaultValue={item.type_price} value={namaTypePrice} onChange={(e) => setNamaTypePrice(e.target.value)} />
                                </div>
                            </div>
                            ))}
                            

                            <div class="row mb-3">
                              <label for="inputText" class="col-sm-2 col-form-label"></label>
                                <div class="col-sm-10">
                                    <button type="submit" className="button_simpan" disabled={loading}>
                                      {loading ? (
                                        <i
                                          className="fa fa-refresh fa-spin"
                                          style={{ marginRight: "5px" }}
                                        />
                                      ):
                                      (<i
                                        className="fa fa-save"
                                        style={{ marginRight: "5px" }}
                                      />)} &nbsp;
                                      {loading && <span>Harap Tunggu ...</span>}
                                      {!loading && <span>Simpan</span>}
                                    </button>
                                </div>
                            </div>

                            </form>

                      </div>
                    </div>

                  </div>
                </div>
              </section>

            </main>
            <Footer_admin></Footer_admin>
        </div>
        
  );
}

export default Edit_type_price;